// Helpers
import { extractTokenAuthorization } from '../helpers';

export const UserMapper = {

    transformUserInfo: (userInfo) => {

        return {
            user: {
                metadata: {

                    ...userInfo
                },			
                permissions: []
            }
        }
    },

    transformApiInfo: (accessToken) => {

        const apiInfo = extractTokenAuthorization(accessToken);

        return {
            api: { ...apiInfo }
        }
    }
};